<template>

  <div id="main" class="main">
    <Header></Header>
    <Notice>
      <Trans>
        <template v-slot:en>
          <a href="https://twitter.com/i/communities/1493522973533298688" target="_blank">Join ThatSkyGame Twitter
            Community</a>
        </template>
        <template v-slot:jp>
          <a href="https://twitter.com/i/communities/1493522973533298688"
             target="_blank">ThatSkyGameTwitterコミュニティに参加する</a>
        </template>
      </Trans>
    </Notice>
    <div class="skycard-container" ref="skycardContainer">
      <Skycard ref="skycard"></Skycard>
    </div>
    <div class="download-button">
      <Button @click="$refs.skycard.cycleBackground()" class="left">
        <Trans>
          <template v-slot:en>
            Random Background
          </template>
          <template v-slot:jp>
            背景を変更する
          </template>
        </Trans>
      </Button>
      <Button @click="$refs.skycard.uploadBackground()" class="right">
        <Trans>
          <template v-slot:en>
            Upload Background
          </template>
          <template v-slot:jp>
            背景をアップロード
          </template>
        </Trans>
      </Button>
      <Button @click="renderSkycard()" class="right">
        <Trans>
          <template v-slot:en>
            Download
          </template>
          <template v-slot:jp>
            ダウンロード
          </template>
        </Trans>
      </Button>
    </div>

    <div class="canvas-container" ref="canvasContainer" v-show="render">
      <img class="canvas-renderer" ref="canvasRenderer" alt="">
      <Button @click="render = false">
        <Trans>
          <template v-slot:en>
            Close
          </template>
          <template v-slot:jp>
            クローズ
          </template>
        </Trans>
      </Button>
    </div>
    <footer>
      <p>
        All rights reserved, crafted by <a href="https://twitter.com/lucentshard_" target="_blank"
                                           rel="noreferrer noopener">Lucentshard</a> - {{new Date().getFullYear()}}
      </p>
      <p>Skycard is not affiliated with ThatGameCompany.</p>
      <p>ThatSkyGame / Sky: Children of The Light is a trademark of ThatGameCompany.</p>
      <p>Google Analytics is used to measure the number of visitors of this website.</p>
      <p>Skycard and its affiliations are not responsible for the damage caused by using this software.</p>
    </footer>
    <div class="modal" v-if="showNewModal" @click.self="showNewModal=false">
      <div class="modal-content">
        <LangSwitch></LangSwitch>
        <Trans>
          <template v-slot:en>
            <p>
              <strong>ThatSkyGame Community</strong> We now have our very own community on Twitter! Be the early members
              of the community and starts sharing with other players.
            </p>
          </template>
          <template v-slot:jp>
            <p>
              <strong>ThatSkyGame コミュニティ</strong> Twitterに独自のコミュニティができました！ コミュニティの初期のメンバーになり、他のプレイヤーと共有し始めます。
            </p>
          </template>
        </Trans>
        <ButtonLink href="https://twitter.com/i/communities/1493522973533298688/" target="_blank"
                    @click="showNewModal=false">
          <Trans>
            <template v-slot:en>
              Join The Community
            </template>
            <template v-slot:jp>
              コミュニティに参加する
            </template>
          </Trans>
        </ButtonLink>
      </div>
    </div>
  </div>

</template>

<script>
import Header from './header/Header'
import Notice from '../components/text/Notice'
import Trans from '../components/text/Trans'
import Skycard from './card/Skycard'
import Button from '../components/Button'
import html2canvas from 'html2canvas'
import LangSwitch from './header/LangSwitch'
import ButtonLink from "../components/ButtonLink.vue";

export default {
  name: 'Main',
  components: {ButtonLink, LangSwitch, Button, Skycard, Trans, Notice, Header},
  data() {
    return {
      render: false,
      showNewModal: false
    }
  },
  methods: {
    renderSkycard() {
      this.$refs.skycardContainer.style.position = 'fixed'
      this.$refs.skycardContainer.style.background = '#fff'
      this.$refs.skycardContainer.style.top = '0'
      this.$refs.skycardContainer.style.left = '0'
      this.$refs.skycardContainer.style.padding = '0'
      this.$refs.skycardContainer.style.maxWidth = '420px'
      setTimeout(() => {
        html2canvas(this.$refs.skycardContainer).then(canvas => {
          this.render = true

          setTimeout(() => {
            const url = canvas.toDataURL()

            this.$refs.skycardContainer.style.position = 'static'
            this.$refs.skycardContainer.style.top = '0'
            this.$refs.skycardContainer.style.left = '0'
            this.$refs.skycardContainer.style.padding = '16px'
            this.$refs.skycardContainer.style.background = '#fff'
            this.$refs.skycardContainer.style.maxWidth = 'none'
            this.$refs.canvasRenderer.src = `${url}`
          }, 1000)
        }).catch(err => {
          alert(err)
        })
      }, 1500)
    }
  },
  mounted() {
    const newModalSeen = localStorage.getItem('skycommunity-modal-seen')
    if (!newModalSeen) {
      this.showNewModal = true
      localStorage.setItem('skycommunity-modal-seen', 'true')
    }
  }
}
</script>
<style scoped>
.skycard-container {
  padding: 16px;
}

.canvas-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  text-align: center;
  background: #000c;
  padding: 16px;
  box-sizing: border-box;
  z-index: 10;
}

.canvas-renderer {
  width: 100%;
  height: 75%;
  object-fit: contain;
}

.download-button {
  margin: 0 16px;
  display: grid;
  grid-gap: 4px;
  grid-template-columns: repeat(3, 1fr);
}


footer {
  font-size: 13px;
  text-align: left;
  margin: 16px;
}

footer p {
  margin: 0 0 4px;
  padding: 0;
}

footer p:first-child {
  margin-bottom: 16px;
}

footer p:not(:first-child) {
  opacity: 0.5;
}

.modal {
  background: #000a;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  padding: 16px;
  color: #333;
  margin: 32px;
  border-radius: 4px;
  max-width: 50%;
}
</style>
<style>
:root {
  --accent: #3Af;
  --accent-link: #2271a9;
}

[contenteditable]:focus {
  outline: solid 1px var(--accent);
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans JP', -apple-system,sans-serif;
}

a {
  color: var(--accent-link);
}

@media only screen and (min-width: 767px) {
  .main {
    width: 420px;
    margin: auto;
  }
}

</style>
